/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAddressesRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/address_service.pb'
import {GetAddressesResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/address_service.pb'


export const getAddresses = (request: GetAddressesRequest, options?: CashRequestOptions) => post<GetAddressesRequest, GetAddressesResponse>("/2.0/cash/get-addresses", request, {...options, rejectOnError: true })